<div class="ion-padding">
  <canvas #barCanvas style="position: relative; height:20vh; width:100%"></canvas>
</div>